import { Form } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import { ALL_SITUATIONS_COMPROVANTES_SINDICATO } from "./comprovantesSindicatoTypes";
import "../FilterSectionPayment/FilterSectionPayment.css";

export interface FilterSectionComprovantesSindicatoProps {
  selectedSituation?: string[];
  handleSituationFilter: (value: string | string[]) => void;
  allSituations?: readonly string[];
}

const FilterSectionComprovantesSindicato = ({
  selectedSituation = [],
  handleSituationFilter,
  allSituations = ALL_SITUATIONS_COMPROVANTES_SINDICATO,
}: FilterSectionComprovantesSindicatoProps) => {
  const isAllSelected =
    allSituations.length > 0 &&
    allSituations.every((s) => selectedSituation.includes(s));

  const toggleOne = (label: string) => {
    handleSituationFilter(label);
  };

  const toggleAll = () => {
    if (isAllSelected) {
      handleSituationFilter([]);
      return;
    }
    handleSituationFilter([...allSituations]);
  };

  return (
    <div className="filters-section">
      <div className="filter-label">
        <FaFilter style={{ marginRight: "5px" }} /> Filtro situação:
      </div>

      <div className="checkbox-grid">
        <div className="checkbox-line checkbox-line-all">
          <Form.Check
            inline
            label="Todos"
            type="checkbox"
            checked={isAllSelected}
            onChange={toggleAll}
          />
          <Form.Check
            inline
            label="Comprovantes Pendentes"
            type="checkbox"
            checked={selectedSituation.includes("Comprovantes pendentes")}
            onChange={() => toggleOne("Comprovantes pendentes")}
          />
          <Form.Check
            inline
            label="Comprovantes Enviados"
            type="checkbox"
            checked={selectedSituation.includes("Comprovantes enviados")}
            onChange={() => toggleOne("Comprovantes enviados")}
          />
        </div>

        <div className="checkbox-line">
          <Form.Check
            inline
            label="Correção Pendente"
            type="checkbox"
            checked={selectedSituation.includes("Correção pendente")}
            onChange={() => toggleOne("Correção pendente")}
          />
          <Form.Check
            inline
            label="Assinatura Pendente"
            type="checkbox"
            checked={selectedSituation.includes("Assinatura pendente")}
            onChange={() => toggleOne("Assinatura pendente")}
          />
          <Form.Check
            inline
            label="Assinatura Expirada"
            type="checkbox"
            checked={selectedSituation.includes("Assinatura expirada")}
            onChange={() => toggleOne("Assinatura expirada")}
          />
          <Form.Check
            inline
            label="Assinatura Concluída"
            type="checkbox"
            checked={selectedSituation.includes("Assinatura Concluída")}
            onChange={() => toggleOne("Assinatura Concluída")}
          />
        </div>

        <div className="checkbox-line">
          <Form.Check
            inline
            label="Inapto"
            type="checkbox"
            checked={selectedSituation.includes("Inapto")}
            onChange={() => toggleOne("Inapto")}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterSectionComprovantesSindicato;
